// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"42e356cc","977":"07c22e4d"}[chunkId] + ".chunk.js";
};